import type { GaEventBaseParams } from '@/interfaces';
import { getGaClientId, getSessionId } from '@/modules/pmt/utils/ga4.utils';
import useGlobalState from './useGlobalState.hooks';

const useGaEventBaseParams = () => {
  const { isMultiLanguagePage } = useGlobalState();

  return (): GaEventBaseParams => ({
    clientId: getGaClientId(),
    sessionId: getSessionId(isMultiLanguagePage),
    eventTimestamp: Date.now().toString(),
  });
};

export default useGaEventBaseParams;
